import { render, staticRenderFns } from "./GamificationProfile.vue?vue&type=template&id=3ebc7a9a&scoped=true"
import script from "./GamificationProfile.vue?vue&type=script&setup=true&lang=js"
export * from "./GamificationProfile.vue?vue&type=script&setup=true&lang=js"
import style0 from "./GamificationProfile.vue?vue&type=style&index=0&id=3ebc7a9a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ebc7a9a",
  null
  
)

export default component.exports